<!-- Copyright 2023 (Unpublished) Verto Inc. -->

<div *ngIf="!!currentUserService.token" class="logs-container breadcrumb-container">
  <div *ngFor="let breadcrumb of breadcrumbList">
    <div class="breadcrumb-path">
      <!-- Label -->
      <a *ngIf="breadcrumb.url" [routerLink]="breadcrumb.url" class="breadcrumb-path-active">
        {{ breadcrumb.label }}
      </a>
      <div *ngIf="!!!breadcrumb.url" class="breadcrumb-path-inactive">
        {{ breadcrumb.label }}
      </div>
      <!-- Path separator -->
      <div *ngIf="!breadcrumb.last" class="breadcrumb-path-separator">
        <fa-icon [icon]="faChevronRight" size="sm"></fa-icon>
      </div>
    </div>
  </div>
</div>
